module.exports = __webpack_public_path__ + "img/US_HealRate_ua.49ddc3d1.webp";